import styled from 'styled-components';

import { LoadingProps } from './Loading';

const StyledLoading = styled.div<LoadingProps>`
  border: none;
  color: #fff;
  ${({ size }) =>
    size &&
    `
    width: ${size}px;
    height: ${size}px;
  `};
`;

export { StyledLoading };
